import { render, staticRenderFns } from "./SafetyStatistics.vue?vue&type=template&id=1f017f45&"
import script from "./SafetyStatistics.vue?vue&type=script&lang=js&"
export * from "./SafetyStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports